import type { ClientEnvironment } from "@/features/clientEnv";
import { getCountryAsset } from "@/utils/countryAssetUtils";

/**
 * Shared country-aware artwork for install prompts.
 *
 * The online-package retirement gate deliberately reuses the same artwork as
 * the post-registration install prompt so both entries stay visually aligned.
 */
export const getInstallAfterAuthPromptBannerImage = (
  env?: ClientEnvironment,
): string =>
  getCountryAsset(
    env?.isFacebookFamilyIAB
      ? "installBannerFacebook"
      : "installBannerDefault",
  );
